import { Link } from "react-router-dom";
import { useWordPressFooterSettings } from "@/hooks/useWordPress";
import { openPrivacyPreferences } from "@/lib/consent";

const Footer = () => {
  const { data: footerSettings, isLoading } = useWordPressFooterSettings();

  const currentYear = new Date().getFullYear();

  const companyName = footerSettings?.companyName || "The Famous Group";
  const tagline = footerSettings?.tagline || "A Creative Technology Company";
  const copyright =
    footerSettings?.copyright ||
    `© ${currentYear} Famous Group Technologies Inc. All rights reserved.`;
  const links =
    footerSettings?.links && footerSettings.links.length > 0
      ? footerSettings.links
      : [
          { label: "Our Experiences", url: "/solutions" },
          { label: "Our Work", url: "/work" },
          { label: "Company", url: "/company" },
          { label: "Contact", url: "/contact" },
        ];

  return (
    <footer className="bg-charcoal-dark border-t border-border py-12">
      <div className={`content-container transition-opacity duration-300 ${isLoading ? "opacity-0" : "opacity-100"}`}>
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo / Brand */}
          <div className="text-center md:text-left animate-[fadeIn_0.6s_ease-out_both]">
            <h4 className="text-xl font-bold text-foreground mb-1">
              {companyName}
            </h4>
            <p className="text-sm text-muted-foreground">
              {tagline}
            </p>
          </div>

          {/* Links */}
          <nav className="flex gap-8">
            {links.map((link) => {
              const isExternal = link.url.startsWith("http");
              return isExternal ? (
                <a
                  key={link.label}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.label}
                  to={link.url}
                  onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "auto" })}
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>

          {/* Copyright */}
          <p className="text-sm text-muted-foreground">
            {copyright}
          </p>
        </div>
        {/* Legal / privacy */}
          <div className="w-full mt-6 flex flex-wrap justify-center md:justify-end gap-x-5 gap-y-2 text-xs text-muted-foreground">
            <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy Policy</Link>
            <Link to="/cookies" className="hover:text-foreground transition-colors">Cookie &amp; Tracking Policy</Link>
            <Link to="/terms" className="hover:text-foreground transition-colors">Terms of Use</Link>
            <button type="button" data-analytics-skip onClick={openPrivacyPreferences} className="hover:text-foreground transition-colors">Privacy Choices</button>
          </div>
      </div>
    </footer>
  );
};

export default Footer;